import { ActionType } from './action-type.model';

export class Permission {
  public securityAction = '';
  public securityActionTypes: ActionType[] =[];
}
